<template>
  <layout-main-inner title="企业增值服务">
    <div class="custom-main-inner">
      <div class="service-nav">
        <el-card shadow="never">
          <div class="nav-item"
               v-for="item in list"
               @click="selectItem(item.id)"
               :class="{ 'is-active': item.id === currentId }"
               :key="item.id">{{item.serviceName}}</div>
        </el-card>
        <el-card shadow="never"
                 class="contract-us">
          <div class="nav-item"
               @click="selectItem(999)"
               :class="{ 'is-active': 999 === currentId }">联系我们</div>
        </el-card>
      </div>
      <el-card shadow="never"
               class="service-detail">
            <service-detail :item="currentInfo" />
      </el-card>
    </div>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import ServiceDetail from './busi/service-detail.vue'
const PLATFORM_KEY = 'platform-info'
export default {
  name: 'vendor-service-introduce-detail',
  components: { ServiceDetail },
  data () {
    return {
      loading: false,
      currentId: null,
      list: [],
      ruleForm: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    }),
    currentInfo ({ currentId, list, ruleForm }) {
      if (currentId === 999) {
        return {
          ...ruleForm,
          serviceName: ruleForm.name,
          serviceIntro: ruleForm.desc,
          hasMore: true
        }
      } else {
        return list.find(i => i.id === currentId)
      }
    }
  },
  methods: {
    selectItem (id) {
      this.currentId = id
    },
    getkeyvaluebykey () {
      this.loading = true
      this.$$CommonApi.getkeyvaluebykey({ topic: PLATFORM_KEY, k: PLATFORM_KEY })
        .then(res => {
          this.loading = false
          const { result, v } = res.data
          if ([0].includes(result)) {
            this.ruleForm = { ...this.ruleForm, ...JSON.parse(v) }
            // this.ruleForm.v = this.$splitImages(v)
          } else {
            this.$message.error('获取平台信息失败')
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetchList () {
      this.loading = true
      this.$$VendorApi.getsvrrecommends({ vendorId: this.userInfo.orgId, pageNum: 1, pageSize: 100 })
        .then(res => {
          const { result, message, records } = res.data
          this.loading = false
          if ([0, 13].includes(result)) {
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    }
  },
  mounted () {
    this.currentId = +this.$route.query.id
    this.fetchList()
    this.getkeyvaluebykey()
  }
}
</script>
<style lang="stylus" scoped>
.custom-main-inner {
  display: flex;

  .service-nav {
    width: 280px;
    flex: 0 0 280px;
    margin-right: 24px;

    /deep/ .el-card__body {
      padding: 0 !important;
    }

    .nav-item {
      text-align: center;
      height: 72px;
      line-height: 72px;
      font-size: 18px;
      color: #2F3032;
      font-weight: bold;
      cursor: pointer;

      &.is-active {
        color: #1890FF;
      }
    }

    .nav-item+.nav-item {
      border-top: 1px solid #EBEEF5;
    }

    .contract-us {
      margin-top: 24px;
    }
  }

  .service-detail {
    flex: 1;
  }
}
</style>
